import * as moment from 'moment';

export function formatDateForExcel(date: any): string {
  if (!date) return '';
  const parsed = moment(date, [
    'DD-MM-YYYY',
    'DD/MM/YYYY',
    'YYYY-MM-DD',
    'MM/DD/YYYY',
    'M/D/YYYY',
    'D/M/YYYY',
    'YYYYMMDD',
  ], true);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
}
